import type { ChannelId } from '../fixtures/domain.js';

/**
 * The next selection when the select-all box is toggled. Every visible row
 * already picked → clear everything; otherwise add every visible row to the
 * picks (off-screen picks are kept until the box is toggled back off).
 */
export function selectAllNext(
  selected: ChannelId[],
  visibleIds: ChannelId[],
  allVisibleSelected: boolean,
): ChannelId[] {
  if (allVisibleSelected) return [];
  return Array.from(new Set([...selected, ...visibleIds]));
}
